import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const InputGroupAddon = ({ children, ...rest }) => {
  const theme = useTheme();
  const { wrenchInputGroupAddon } = useStyles({ theme });
  return (
    <div className={wrenchInputGroupAddon} {...safeRest(rest)}>
      {children}
    </div>
  );
};

InputGroupAddon.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InputGroupAddon;
